function Footer() {
  return (
    <div>
      Built by{' '}
      <a
        className="portfolio-link"
        href="https://woosikchoi.com"
        target="_blank"
        rel="noopenner noreferrer"
      >
        Woo-Sik Choi
      </a>{' '}
      in December 2021
    </div>
  );
}

export default Footer;
